module.exports = __webpack_public_path__ + "img/logo3.79cb70bc.png";